import { render, staticRenderFns } from "./TitleSummary.vue?vue&type=template&id=120140d6&scoped=true&"
import script from "./TitleSummary.vue?vue&type=script&lang=js&"
export * from "./TitleSummary.vue?vue&type=script&lang=js&"
import style0 from "./TitleSummary.vue?vue&type=style&index=0&id=120140d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120140d6",
  null
  
)

export default component.exports